/**
 * Canonical organizations used across admin (onboarding, employees, tasks).
 * Keep in sync when adding a new company to the product.
 */
export const ORGANIZATION_OPTIONS = [
  'Regal Fintech',
  'Bharatmart',
  'PFS',
  'Yummz Food',
  'SwarnSathi',
  'RegalFincorp',
];
